import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "linkedin-activities-tab" }
const _hoisted_2 = { class: "activities-tabs" }
const _hoisted_3 = { class: "activities-content" }
const _hoisted_4 = {
  key: 0,
  class: "error-state"
}
const _hoisted_5 = { class: "error-message" }
const _hoisted_6 = {
  key: 1,
  class: "loading-state"
}
const _hoisted_7 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 3,
  class: "posts-content"
}
const _hoisted_12 = {
  key: 0,
  class: "repost-header"
}
const _hoisted_13 = { class: "repost-label" }
const _hoisted_14 = { class: "post-header" }
const _hoisted_15 = { class: "post-author" }
const _hoisted_16 = {
  key: 0,
  class: "author-headline"
}
const _hoisted_17 = {
  key: 1,
  class: "company-badge"
}
const _hoisted_18 = { class: "post-date" }
const _hoisted_19 = {
  key: 1,
  class: "post-title"
}
const _hoisted_20 = {
  key: 2,
  class: "activity-text"
}
const _hoisted_21 = {
  key: 3,
  class: "repost-content"
}
const _hoisted_22 = { class: "repost-content-header" }
const _hoisted_23 = { class: "repost-content-date" }
const _hoisted_24 = {
  key: 0,
  class: "repost-content-text"
}
const _hoisted_25 = {
  key: 4,
  class: "post-attachments"
}
const _hoisted_26 = {
  key: 5,
  class: "activity-media"
}
const _hoisted_27 = { class: "image-grid" }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 6,
  class: "post-poll"
}
const _hoisted_30 = { class: "poll-question" }
const _hoisted_31 = { class: "poll-options" }
const _hoisted_32 = { class: "poll-option-header" }
const _hoisted_33 = { class: "poll-option-text" }
const _hoisted_34 = { class: "poll-option-votes" }
const _hoisted_35 = { class: "poll-footer" }
const _hoisted_36 = { class: "poll-total-votes" }
const _hoisted_37 = {
  key: 0,
  class: "poll-status"
}
const _hoisted_38 = {
  key: 1,
  class: "poll-status poll-status--closed"
}
const _hoisted_39 = {
  key: 7,
  class: "post-group"
}
const _hoisted_40 = {
  key: 0,
  class: "group-private"
}
const _hoisted_41 = { class: "activity-engagement" }
const _hoisted_42 = { class: "engagement-metrics" }
const _hoisted_43 = {
  key: 0,
  class: "metric-item"
}
const _hoisted_44 = {
  key: 1,
  class: "metric-item"
}
const _hoisted_45 = {
  key: 2,
  class: "metric-item"
}
const _hoisted_46 = {
  key: 3,
  class: "metric-item"
}
const _hoisted_47 = ["href"]
const _hoisted_48 = {
  key: 8,
  class: "user-reaction"
}
const _hoisted_49 = {
  key: 9,
  class: "post-analytics"
}
const _hoisted_50 = { class: "analytics-details" }
const _hoisted_51 = { class: "analytics-summary" }
const _hoisted_52 = { class: "analytics-content" }
const _hoisted_53 = { class: "analytics-item" }
const _hoisted_54 = { class: "analytics-value" }
const _hoisted_55 = { class: "analytics-item" }
const _hoisted_56 = { class: "analytics-value" }
const _hoisted_57 = { class: "analytics-item" }
const _hoisted_58 = { class: "analytics-value" }
const _hoisted_59 = {
  key: 0,
  class: "analytics-item"
}
const _hoisted_60 = { class: "analytics-value" }
const _hoisted_61 = {
  key: 1,
  class: "analytics-item"
}
const _hoisted_62 = { class: "analytics-value" }
const _hoisted_63 = {
  key: 4,
  class: "comments-content"
}
const _hoisted_64 = { class: "comment-header" }
const _hoisted_65 = { class: "comment-author" }
const _hoisted_66 = { class: "author-info" }
const _hoisted_67 = { class: "author-details" }
const _hoisted_68 = {
  key: 0,
  class: "author-headline"
}
const _hoisted_69 = {
  key: 1,
  class: "network-distance"
}
const _hoisted_70 = { class: "comment-date" }
const _hoisted_71 = { class: "comment-text" }
const _hoisted_72 = { class: "comment-engagement" }
const _hoisted_73 = { class: "engagement-metrics" }
const _hoisted_74 = {
  key: 0,
  class: "metric-item"
}
const _hoisted_75 = {
  key: 1,
  class: "metric-item"
}
const _hoisted_76 = {
  key: 2,
  class: "metric-item"
}
const _hoisted_77 = ["href"]
const _hoisted_78 = {
  key: 0,
  class: "user-reaction"
}
const _hoisted_79 = {
  key: 5,
  class: "reactions-content"
}
const _hoisted_80 = { class: "reaction-header" }
const _hoisted_81 = { class: "reaction-author" }
const _hoisted_82 = { class: "author-info" }
const _hoisted_83 = { class: "author-details" }
const _hoisted_84 = {
  key: 0,
  class: "author-headline"
}
const _hoisted_85 = {
  key: 1,
  class: "network-distance"
}
const _hoisted_86 = { class: "reaction-type-badge" }
const _hoisted_87 = { class: "reaction-type-text" }
const _hoisted_88 = { class: "reaction-content" }
const _hoisted_89 = {
  key: 0,
  class: "reaction-target"
}
const _hoisted_90 = ["href"]
const _hoisted_91 = {
  key: 1,
  class: "reaction-target"
}
const _hoisted_92 = ["href"]
const _hoisted_93 = {
  key: 1,
  class: "reaction-link",
  style: {"color":"#9ca3af","cursor":"default"}
}

import type { Comment, Post, PostReaction } from "@/dtos/Unipile.dto";
import Unipile from "@/services/unipile/unipile";
import Button from "@/components/ui/Button.vue";
import AttachmentPreview from "@/components/socials/AttachmentPreview.vue";
import { Icon } from "@iconify/vue";
import LoadingBars from "@/components/ui/LoadingBars.vue";
import { computed, onMounted, ref, watch } from "vue";

interface Props {
  accountId?: string;
  identifier?: string;
  followers?: number;
  cache?: Record<string, any>;
}

type TabType = "posts" | "comments" | "reactions";

interface TabState<T> {
  items: T[];
  cursor: string | null;
  loading: boolean;
  error: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkedInActivitiesTab',
  props: {
    accountId: { default: undefined },
    identifier: { default: undefined },
    followers: { default: 0 },
    cache: { default: () => ({}) }
  },
  emits: ["cache-update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const activeTab = ref<TabType>("posts");
const postsState = ref<TabState<Post>>({
  items: [],
  cursor: null,
  loading: false,
  error: null,
});
const commentsState = ref<TabState<Comment>>({
  items: [],
  cursor: null,
  loading: false,
  error: null,
});
const reactionsState = ref<TabState<PostReaction>>({
  items: [],
  cursor: null,
  loading: false,
  error: null,
});

const error = ref<string | null>(null);
const errorType = ref<"not-found" | "generic" | null>(null);

const formattedFollowers = computed(() => {
  return (props.followers || 0).toLocaleString();
});

const currentItems = computed(() => {
  if (activeTab.value === "posts") return postsState.value.items;
  if (activeTab.value === "comments") return commentsState.value.items;
  if (activeTab.value === "reactions") return reactionsState.value.items;
  return [];
});

const isLoading = computed(() => {
  if (activeTab.value === "posts")
    return postsState.value.loading && postsState.value.items.length === 0;
  if (activeTab.value === "comments")
    return commentsState.value.loading && commentsState.value.items.length === 0;
  if (activeTab.value === "reactions")
    return reactionsState.value.loading && reactionsState.value.items.length === 0;
  return false;
});

const isLoadingMore = computed(() => {
  if (activeTab.value === "posts")
    return postsState.value.loading && postsState.value.items.length > 0;
  if (activeTab.value === "comments")
    return commentsState.value.loading && commentsState.value.items.length > 0;
  if (activeTab.value === "reactions")
    return reactionsState.value.loading && reactionsState.value.items.length > 0;
  return false;
});

const formatDate = (dateString?: string): string => {
  if (!dateString) return "";
  if (/^\d+\s*(yr|yrs|y|mo|w|d|h)$/i.test(dateString.trim())) {
    return dateString.trim();
  }

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return dateString;
    }

    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return "Just now";
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    const diffWeeks = Math.floor(diffDays / 7);
    if (diffDays < 30) return `${Math.max(1, diffWeeks)}w`;
    const diffMonths = Math.floor(diffDays / 30);
    if (diffDays < 365) return `${Math.max(1, diffMonths)}mo`;
    const diffYears = Math.floor(diffDays / 365);
    return `${Math.max(1, diffYears)}y`;
  } catch {
    return dateString;
  }
};

const formatNumber = (num: number): string => {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1)}M`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1)}K`;
  }
  return num.toString();
};

const getReactionIcon = (reaction: string): string => {
  const iconMap: Record<string, string> = {
    LIKE: "ei:like",
    LOVE: "mdi:heart",
    PRAISE: "mdi:hand-heart",
    APPRECIATION: "mdi:hand-heart",
    EMPATHY: "mdi:heart-outline",
    INTEREST: "mdi:lightbulb",
    ENTERTAINMENT: "mdi:emoticon-lol",
    CELEBRATE: "mdi:party-popper",
    SUPPORT: "mdi:hand-heart",
    FUNNY: "mdi:emoticon-lol",
    INSIGHTFUL: "mdi:lightbulb",
    CURIOUS: "mdi:help-circle",
  };
  return iconMap[reaction] || "ei:like";
};

const formatReactionType = (reaction?: string): string => {
  if (!reaction) return "Like";
  const typeMap: Record<string, string> = {
    LIKE: "Like",
    LOVE: "Love",
    PRAISE: "Praise",
    APPRECIATION: "Appreciation",
    EMPATHY: "Empathy",
    INTEREST: "Interest",
    ENTERTAINMENT: "Entertainment",
    CELEBRATE: "Celebrate",
    SUPPORT: "Support",
    FUNNY: "Funny",
    INSIGHTFUL: "Insightful",
    CURIOUS: "Curious",
  };
  return typeMap[reaction] || reaction;
};

const isLinkedInCompany = (identifier: string): boolean => {
  return /^[0-9]+$/.test(identifier);
};

const formatNetworkDistance = (distance?: string): string => {
  if (!distance) return "";
  const distanceMap: Record<string, string> = {
    FIRST_DEGREE: "1st connection",
    SECOND_DEGREE: "2nd connection",
    THIRD_DEGREE: "3rd connection",
  };
  return distanceMap[distance] || distance;
};

const handleError = (err: any, tab: TabType) => {
  console.error(`Failed to load ${tab}:`, err);

  const status = err.response?.status;
  const errorData = err.response?.data;

  const getErrorMessage = () => {
    if (errorData?.providerError?.detail) {
      return errorData.providerError.detail;
    }
    if (errorData?.error?.body?.detail) {
      return errorData.error.body.detail;
    }
    if (errorData?.errorMessage) {
      return errorData.errorMessage;
    }
    if (errorData?.message) {
      return errorData.message;
    }
    if (errorData?.providerError?.title) {
      return errorData.providerError.title;
    }
    if (err.message) {
      return err.message;
    }
    return null;
  };

  const extractedMessage = getErrorMessage();
  let userMessage = `Failed to load ${tab}.`;

  switch (status) {
    case 400:
      if (
        extractedMessage?.toLowerCase().includes("identifier") &&
        extractedMessage?.toLowerCase().includes("required")
      ) {
        userMessage = "LinkedIn profile identifier is required.";
      } else if (
        extractedMessage?.toLowerCase().includes("account_id") &&
        extractedMessage?.toLowerCase().includes("required")
      ) {
        userMessage = "LinkedIn account ID is required.";
      } else if (extractedMessage?.toLowerCase().includes("limit")) {
        userMessage = "Invalid limit. Please use a value between 1 and 100.";
      } else if (extractedMessage?.toLowerCase().includes("cursor")) {
        userMessage = "Invalid cursor for pagination.";
      } else {
        userMessage = extractedMessage || "Invalid request. Please check your parameters.";
      }
      errorType.value = "generic";
      break;
    case 401:
      if (extractedMessage?.toLowerCase().includes("disconnected")) {
        userMessage =
          "Your LinkedIn account appears to be disconnected. Please reconnect your account.";
      } else {
        userMessage = extractedMessage || "Unauthorized. Please check your credentials.";
      }
      errorType.value = "generic";
      break;
    case 403:
      userMessage =
        extractedMessage || "This feature is not available for your subscription or account type.";
      errorType.value = "generic";
      break;
    case 404:
      if (extractedMessage?.toLowerCase().includes("account not found")) {
        userMessage = "LinkedIn account not found. Please check your account settings.";
      } else {
        userMessage =
          extractedMessage || "Account or user not found. The requested resource was not found.";
      }
      errorType.value = "not-found";
      break;
    case 422:
      if (extractedMessage?.toLowerCase().includes("cannot be reached")) {
        userMessage =
          "Recipient cannot be reached. Make sure the identifier is valid and the profile is not locked.";
      } else {
        userMessage =
          extractedMessage ||
          "Unable to process request. Please check the identifier and try again.";
      }
      errorType.value = "generic";
      break;
    case 429:
      userMessage = extractedMessage || "Too many requests. Please wait a moment and try again.";
      errorType.value = "generic";
      break;
    case 502:
      if (extractedMessage?.toLowerCase().includes("account not found")) {
        userMessage = "LinkedIn account not found. Please check your account settings.";
      } else {
        userMessage =
          extractedMessage ||
          "LinkedIn service is temporarily unavailable. Please try again later.";
      }
      errorType.value = "generic";
      break;
    case 500:
    case 503:
    case 504:
      userMessage =
        extractedMessage || "LinkedIn service is temporarily unavailable. Please try again later.";
      errorType.value = "generic";
      break;
    default:
      userMessage = extractedMessage || "An unexpected error occurred. Please try again.";
      errorType.value = "generic";
  }

  error.value = userMessage;
};

const getCacheKey = () => {
  if (!props.identifier || !props.accountId) return null;
  return `${props.identifier}-${props.accountId}`;
};

const loadPosts = async (cursor?: string) => {
  if (!props.identifier) {
    error.value = "LinkedIn profile identifier is required to load posts.";
    errorType.value = "generic";
    return;
  }

  if (!props.accountId) {
    error.value = "LinkedIn account ID is required to load posts.";
    errorType.value = "generic";
    return;
  }

  const cacheKey = getCacheKey();
  if (!cursor && cacheKey && props.cache?.[cacheKey]?.posts) {
    const cached = props.cache[cacheKey].posts;
    postsState.value.items = cached.items || [];
    postsState.value.cursor = cached.cursor || null;
    return;
  }

  try {
    error.value = null;
    errorType.value = null;
    postsState.value.loading = true;

    const params: any = {
      limit: 25,
      account_id: props.accountId,
    };

    if (cursor) {
      params.cursor = cursor;
    }

    const isCompany = isLinkedInCompany(props.identifier);
    if (isCompany) {
      params.is_company = true;
    }

    const response = await Unipile.getAllPosts(props.identifier, params);
    const data = response.data.data;

    if (cursor) {
      postsState.value.items = [...postsState.value.items, ...(data.items || [])];
    } else {
      postsState.value.items = data.items || [];
    }

    postsState.value.cursor = data.cursor || null;

    // Update cache
    if (cacheKey && !cursor) {
      emit("cache-update", {
        posts: { items: postsState.value.items, cursor: postsState.value.cursor },
        comments: props.cache?.[cacheKey]?.comments || null,
        reactions: props.cache?.[cacheKey]?.reactions || null,
      });
    }
  } catch (err: any) {
    handleError(err, "posts");
  } finally {
    postsState.value.loading = false;
  }
};

const loadComments = async (cursor?: string) => {
  if (!props.identifier) {
    error.value = "LinkedIn profile identifier is required to load comments.";
    errorType.value = "generic";
    return;
  }

  if (!props.accountId) {
    error.value = "LinkedIn account ID is required to load comments.";
    errorType.value = "generic";
    return;
  }

  const cacheKey = getCacheKey();
  if (!cursor && cacheKey && props.cache?.[cacheKey]?.comments) {
    const cached = props.cache[cacheKey].comments;
    commentsState.value.items = cached.items || [];
    commentsState.value.cursor = cached.cursor || null;
    return;
  }

  try {
    error.value = null;
    errorType.value = null;
    commentsState.value.loading = true;

    const params: any = {
      limit: 25,
      account_id: props.accountId,
    };

    if (cursor) {
      params.cursor = cursor;
    }

    const response = await Unipile.getAllComments(props.identifier, params);
    const data = response.data.data;

    if (cursor) {
      commentsState.value.items = [...commentsState.value.items, ...(data.items || [])];
    } else {
      commentsState.value.items = data.items || [];
    }

    commentsState.value.cursor = data.cursor || null;
    if (cacheKey && !cursor) {
      emit("cache-update", {
        posts: props.cache?.[cacheKey]?.posts || null,
        comments: { items: commentsState.value.items, cursor: commentsState.value.cursor },
        reactions: props.cache?.[cacheKey]?.reactions || null,
      });
    }
  } catch (err: any) {
    handleError(err, "comments");
  } finally {
    commentsState.value.loading = false;
  }
};

const loadMorePosts = () => {
  if (postsState.value.cursor) {
    loadPosts(postsState.value.cursor);
  }
};

const loadMoreComments = () => {
  if (commentsState.value.cursor) {
    loadComments(commentsState.value.cursor);
  }
};

const loadReactions = async (cursor?: string) => {
  if (!props.identifier) {
    error.value = "LinkedIn profile identifier is required to load reactions.";
    errorType.value = "generic";
    return;
  }

  if (!props.accountId) {
    error.value = "LinkedIn account ID is required to load reactions.";
    errorType.value = "generic";
    return;
  }

  const cacheKey = getCacheKey();
  if (!cursor && cacheKey && props.cache?.[cacheKey]?.reactions) {
    const cached = props.cache[cacheKey].reactions;
    reactionsState.value.items = cached.items || [];
    reactionsState.value.cursor = cached.cursor || null;
    return;
  }

  try {
    error.value = null;
    errorType.value = null;
    reactionsState.value.loading = true;

    const params: any = {
      limit: 25,
      account_id: props.accountId,
    };

    if (cursor) {
      params.cursor = cursor;
    }

    const response = await Unipile.getAllReactions(props.identifier, params);
    const data = response.data.data;

    if (cursor) {
      reactionsState.value.items = [...reactionsState.value.items, ...(data.items || [])];
    } else {
      reactionsState.value.items = data.items || [];
    }

    reactionsState.value.cursor = data.cursor || null;
    if (cacheKey && !cursor) {
      emit("cache-update", {
        posts: props.cache?.[cacheKey]?.posts || null,
        comments: props.cache?.[cacheKey]?.comments || null,
        reactions: { items: reactionsState.value.items, cursor: reactionsState.value.cursor },
      });
    }
  } catch (err: any) {
    handleError(err, "reactions");
  } finally {
    reactionsState.value.loading = false;
  }
};

const loadMoreReactions = () => {
  if (reactionsState.value.cursor) {
    loadReactions(reactionsState.value.cursor);
  }
};

const switchTab = (tab: TabType) => {
  if (activeTab.value === tab) return;

  activeTab.value = tab;
  error.value = null;
  errorType.value = null;

  if (tab === "posts" && postsState.value.items.length === 0 && !postsState.value.loading) {
    loadPosts();
  } else if (
    tab === "comments" &&
    commentsState.value.items.length === 0 &&
    !commentsState.value.loading
  ) {
    loadComments();
  } else if (
    tab === "reactions" &&
    reactionsState.value.items.length === 0 &&
    !reactionsState.value.loading
  ) {
    loadReactions();
  }
};

const retryCurrentTab = () => {
  error.value = null;
  errorType.value = null;

  if (activeTab.value === "posts") {
    postsState.value.items = [];
    postsState.value.cursor = null;
    loadPosts();
  } else if (activeTab.value === "comments") {
    commentsState.value.items = [];
    commentsState.value.cursor = null;
    loadComments();
  } else if (activeTab.value === "reactions") {
    reactionsState.value.items = [];
    reactionsState.value.cursor = null;
    loadReactions();
  }
};

onMounted(() => {
  if (props.identifier) {
    loadPosts();
  } else {
    error.value = "No profile identifier provided.";
    errorType.value = "generic";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(['tab-button', { active: activeTab.value === 'posts' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (switchTab('posts')))
      }, " Posts ", 2),
      _createElementVNode("button", {
        class: _normalizeClass(['tab-button', { active: activeTab.value === 'comments' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (switchTab('comments')))
      }, " Comments ", 2),
      _createElementVNode("button", {
        class: _normalizeClass(['tab-button', { active: activeTab.value === 'reactions' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (switchTab('reactions')))
      }, " Reactions ", 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (error.value && errorType.value !== 'not-found')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(activeTab.value === "posts"
              ? "Couldn't load posts for this profile"
              : activeTab.value === "comments"
                ? "Couldn't load comments for this profile"
                : "Couldn't load reactions for this profile"), 1),
            _createVNode(Button, {
              variant: "primary",
              size: "sm",
              onClick: retryCurrentTab
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Try Again", -1)
              ]))]),
              _: 1
            })
          ]))
        : (isLoading.value && currentItems.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(LoadingBars, { size: "sm" })
            ]))
          : (!isLoading.value && currentItems.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (activeTab.value === 'posts')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "No posts found for this profile"))
                  : (activeTab.value === 'comments')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, "No comments found for this profile"))
                    : (_openBlock(), _createElementBlock("p", _hoisted_10, "No reactions found for this profile"))
              ]))
            : (activeTab.value === 'posts')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(postsState.value.items, (post, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: post.id || index,
                      class: "activity-card post-card"
                    }, [
                      (post.is_repost && post.reposted_by)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_unref(Icon), {
                              icon: "mdi:repeat",
                              class: "repost-icon"
                            }),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(post.reposted_by.name) + " reposted ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("strong", null, _toDisplayString(post.author?.name || post.written_by?.name || "Unknown"), 1),
                          (post.author?.headline)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(post.author.headline), 1))
                            : _createCommentVNode("", true),
                          (post.author?.is_company)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Company"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_18, [
                          _createVNode(_unref(Icon), {
                            icon: "formkit:datetime",
                            class: "post-date-icon"
                          }),
                          _createTextVNode(" " + _toDisplayString(formatDate(post.parsed_datetime || post.date)), 1)
                        ])
                      ]),
                      (post.title)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_19, _toDisplayString(post.title), 1))
                        : _createCommentVNode("", true),
                      (post.text)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(post.text), 1))
                        : _createCommentVNode("", true),
                      (post.is_repost && post.repost_content)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("strong", null, _toDisplayString(post.repost_content.author?.name || "Unknown"), 1),
                              _createElementVNode("span", _hoisted_23, [
                                _createVNode(_unref(Icon), {
                                  icon: "formkit:datetime",
                                  class: "post-date-icon"
                                }),
                                _createTextVNode(" " + _toDisplayString(formatDate(
                    post.repost_content.parsed_datetime || post.repost_content.date || undefined
                  )), 1)
                              ])
                            ]),
                            (post.repost_content.text)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(post.repost_content.text), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (post.attachments && post.attachments.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(post.attachments, (attachment) => {
                              return (_openBlock(), _createBlock(AttachmentPreview, {
                                key: attachment.id,
                                attachment: attachment,
                                class: "post-attachment"
                              }, null, 8, ["attachment"]))
                            }), 128))
                          ]))
                        : (post.images && post.images.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(post.images.slice(0, 4), (img, imgIndex) => {
                                  return (_openBlock(), _createElementBlock("img", {
                                    key: imgIndex,
                                    src: img,
                                    alt: "Post image",
                                    class: "post-image"
                                  }, null, 8, _hoisted_28))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                      (post.poll)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("h5", _hoisted_30, _toDisplayString(post.poll.question), 1),
                            _createElementVNode("div", _hoisted_31, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(post.poll.options, (option) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: option.id,
                                  class: _normalizeClass(["poll-option", { 'poll-option--winning': option.win }])
                                }, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(option.text), 1),
                                    _createElementVNode("span", _hoisted_34, _toDisplayString(option.votes_count || 0) + " votes", 1)
                                  ]),
                                  (post.poll.total_votes_count && post.poll.total_votes_count > 0)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "poll-option-bar",
                                        style: _normalizeStyle({
                    width: `${((option.votes_count || 0) / (post.poll.total_votes_count || 1)) * 100}%`,
                  })
                                      }, null, 4))
                                    : _createCommentVNode("", true)
                                ], 2))
                              }), 128))
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("span", _hoisted_36, _toDisplayString(post.poll.total_votes_count || 0) + " total votes ", 1),
                              (post.poll.is_open)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Open"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_38, "Closed"))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (post.group)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createVNode(_unref(Icon), { icon: "mdi:account-group" }),
                            _createElementVNode("span", null, _toDisplayString(post.group.name), 1),
                            (post.group.private)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Private"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          (post.reaction_counter !== undefined && post.reaction_counter > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                _createVNode(_unref(Icon), { icon: "ei:like" }),
                                _createTextVNode(" " + _toDisplayString(formatNumber(post.reaction_counter)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (post.comment_counter !== undefined && post.comment_counter > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                                _createVNode(_unref(Icon), { icon: "proicons:comment" }),
                                _createTextVNode(" " + _toDisplayString(formatNumber(post.comment_counter)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (
                  (post.repost_counter !== undefined || post.share_counter !== undefined) &&
                  (post.repost_counter || post.share_counter || 0) > 0
                )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                                _createVNode(_unref(Icon), { icon: "bx:repost" }),
                                _createTextVNode(" " + _toDisplayString(formatNumber(post.repost_counter || post.share_counter || 0)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (post.impressions_counter !== undefined && post.impressions_counter > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, [
                                _createVNode(_unref(Icon), { icon: "nrk:some-share" }),
                                _createTextVNode(" " + _toDisplayString(formatNumber(post.impressions_counter)), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (post.share_url)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: post.share_url,
                              target: "_blank",
                              rel: "noopener noreferrer",
                              class: "view-link"
                            }, [
                              _createVNode(_unref(Icon), { icon: "mdi:open-in-new" }),
                              _cache[4] || (_cache[4] = _createTextVNode(" View on LinkedIn ", -1))
                            ], 8, _hoisted_47))
                          : _createCommentVNode("", true)
                      ]),
                      (post.user_reacted)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _createVNode(_unref(Icon), {
                              icon: getReactionIcon(post.user_reacted)
                            }, null, 8, ["icon"]),
                            _createElementVNode("span", null, "You " + _toDisplayString(post.user_reacted.toLowerCase()) + "d this", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (post.analytics)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _createElementVNode("details", _hoisted_50, [
                              _createElementVNode("summary", _hoisted_51, [
                                _createVNode(_unref(Icon), { icon: "mdi:chart-line" }),
                                _cache[5] || (_cache[5] = _createTextVNode(" View Analytics ", -1))
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("div", _hoisted_53, [
                                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "analytics-label" }, "Impressions:", -1)),
                                  _createElementVNode("span", _hoisted_54, _toDisplayString(formatNumber(post.analytics.impressions || 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "analytics-label" }, "Engagements:", -1)),
                                  _createElementVNode("span", _hoisted_56, _toDisplayString(formatNumber(post.analytics.engagements || 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_57, [
                                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "analytics-label" }, "Engagement Rate:", -1)),
                                  _createElementVNode("span", _hoisted_58, _toDisplayString((post.analytics.engagement_rate || 0).toFixed(2)) + "% ", 1)
                                ]),
                                (post.analytics.clicks)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "analytics-label" }, "Clicks:", -1)),
                                      _createElementVNode("span", _hoisted_60, _toDisplayString(formatNumber(post.analytics.clicks)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (post.analytics.clickthrough_rate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "analytics-label" }, "CTR:", -1)),
                                      _createElementVNode("span", _hoisted_62, _toDisplayString(post.analytics.clickthrough_rate.toFixed(2)) + "% ", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (postsState.value.cursor)
                    ? (_openBlock(), _createBlock(Button, {
                        key: 0,
                        variant: "secondary",
                        size: "md",
                        loading: isLoadingMore.value,
                        disabled: isLoadingMore.value,
                        block: "",
                        onClick: loadMorePosts
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode(" Load More ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading", "disabled"]))
                    : _createCommentVNode("", true)
                ]))
              : (activeTab.value === 'comments')
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentsState.value.items, (comment, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: comment.id || index,
                        class: "activity-card comment-card"
                      }, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("strong", null, _toDisplayString(comment.author || comment.author_details?.id || "Unknown"), 1),
                              _createElementVNode("div", _hoisted_67, [
                                (comment.author_details?.headline)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(comment.author_details.headline), 1))
                                  : _createCommentVNode("", true),
                                (comment.author_details?.network_distance)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(formatNetworkDistance(comment.author_details.network_distance)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("span", _hoisted_70, _toDisplayString(formatDate(comment.date)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_71, _toDisplayString(comment.text || ""), 1),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            (comment.reaction_counter !== undefined && comment.reaction_counter > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_74, [
                                  _createVNode(_unref(Icon), { icon: "ei:like" }),
                                  _createTextVNode(" " + _toDisplayString(formatNumber(comment.reaction_counter)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (comment.reply_counter !== undefined && comment.reply_counter > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_75, [
                                  _createVNode(_unref(Icon), { icon: "mdi:reply-outline" }),
                                  _createTextVNode(" " + _toDisplayString(formatNumber(comment.reply_counter)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (comment.impressions_counter !== undefined && comment.impressions_counter > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_76, [
                                  _createVNode(_unref(Icon), { icon: "nrk:some-share" }),
                                  _createTextVNode(" " + _toDisplayString(formatNumber(comment.impressions_counter)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (comment.post_id)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: `https://www.linkedin.com/feed/update/${comment.post_id}`,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "view-link"
                              }, [
                                _createVNode(_unref(Icon), { icon: "mdi:open-in-new" }),
                                _cache[12] || (_cache[12] = _createTextVNode(" View Post ", -1))
                              ], 8, _hoisted_77))
                            : _createCommentVNode("", true)
                        ]),
                        (comment.user_reacted)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                              _createVNode(_unref(Icon), {
                                icon: getReactionIcon(comment.user_reacted)
                              }, null, 8, ["icon"]),
                              _createElementVNode("span", null, "You " + _toDisplayString(comment.user_reacted.toLowerCase()) + "d this", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    (commentsState.value.cursor)
                      ? (_openBlock(), _createBlock(Button, {
                          key: 0,
                          variant: "secondary",
                          size: "md",
                          loading: isLoadingMore.value,
                          disabled: isLoadingMore.value,
                          block: "",
                          onClick: loadMoreComments
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode(" Load More ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading", "disabled"]))
                      : _createCommentVNode("", true)
                  ]))
                : (activeTab.value === 'reactions')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reactionsState.value.items, (reaction, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: reaction.post_id || reaction.comment_id || index,
                          class: "activity-card reaction-card"
                        }, [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", _hoisted_82, [
                                _createElementVNode("strong", null, _toDisplayString(reaction.author?.name || "Unknown"), 1),
                                _createElementVNode("div", _hoisted_83, [
                                  (reaction.author?.headline)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(reaction.author.headline), 1))
                                    : _createCommentVNode("", true),
                                  (reaction.author?.network_distance)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(formatNetworkDistance(reaction.author.network_distance)), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_86, [
                              _createVNode(_unref(Icon), {
                                icon: getReactionIcon(reaction.value || 'LIKE'),
                                class: "reaction-icon"
                              }, null, 8, ["icon"]),
                              _createElementVNode("span", _hoisted_87, _toDisplayString(formatReactionType(reaction.value)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_88, [
                            (reaction.post_id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                  _createVNode(_unref(Icon), {
                                    icon: "mdi:file-document-outline",
                                    class: "target-icon"
                                  }),
                                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "reaction-target-text" }, "Reacted to a post", -1)),
                                  _createElementVNode("a", {
                                    href: `https://www.linkedin.com/feed/update/${reaction.post_id}`,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    class: "reaction-link"
                                  }, [
                                    _cache[14] || (_cache[14] = _createTextVNode(" View Post ", -1)),
                                    _createVNode(_unref(Icon), {
                                      icon: "mdi:open-in-new",
                                      class: "link-icon"
                                    })
                                  ], 8, _hoisted_90)
                                ]))
                              : (reaction.comment_id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                    _createVNode(_unref(Icon), {
                                      icon: "proicons:comment",
                                      class: "target-icon"
                                    }),
                                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "reaction-target-text" }, "Reacted to a comment", -1)),
                                    (reaction.post_id)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: `https://www.linkedin.com/feed/update/${reaction.post_id}`,
                                          target: "_blank",
                                          rel: "noopener noreferrer",
                                          class: "reaction-link"
                                        }, [
                                          _cache[16] || (_cache[16] = _createTextVNode(" View Post ", -1)),
                                          _createVNode(_unref(Icon), {
                                            icon: "mdi:open-in-new",
                                            class: "link-icon"
                                          })
                                        ], 8, _hoisted_92))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_93, " Comment ID: " + _toDisplayString(reaction.comment_id), 1))
                                  ]))
                                : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128)),
                      (reactionsState.value.cursor)
                        ? (_openBlock(), _createBlock(Button, {
                            key: 0,
                            variant: "secondary",
                            size: "md",
                            loading: isLoadingMore.value,
                            disabled: isLoadingMore.value,
                            block: "",
                            onClick: loadMoreReactions
                          }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createTextVNode(" Load More ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["loading", "disabled"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
    ])
  ]))
}
}

})